
// Test data for Level 3 Fairway Woods Training

export const fairwayWoodTests = [
  {
    id: "fairwayWood-precision",
    title: "Bois de parcours - Précision sur le parcours",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 2, 4, 6, 10 m. Sur le parcours en terrain naturel ou plat, taper 10 balles depuis aux distances A=170, B=180, C=200 m et compter les points selon le cercle d'arrivée.",
    icon: "🎯"
  }
];

// Définition du calcul des points
export const fairwayWoodScoringGuide = {
  balle2m: 6, // Balle à 2 m du trou: 6 points
  balle4m: 4, // Balle à 4 m: 4 points
  balle6m: 2, // Balle à 6 m: 2 points
  balle10m: 1, // Balle à 10 m: 1 point
  balleHors: 0 // Balle hors cercles: 0 point
};
